module.exports = __webpack_public_path__ + "static/media/canada-250.5df4a041.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/country-flags/canada-250.png
// module id = 1264
// module chunks = 0